module.exports = __webpack_public_path__ + "assets/img/tab_sys@2x.481d65bd.png";